import createReducer from '../createReducer';
import {
  SET_WIND_COLORS,
  SET_WIND_ARROW_OPTIONS,
  SET_WIND_PARTICLE_OPTIONS,
  OVERWRITE_CHART_CONFIG,
} from '../../actions/charts';

const scaleInMetersPerSecond = [
  { value: 0, color: [206, 255, 255] },
  { value: 0.51, color: [157, 255, 254] },
  { value: 1.54, color: [155, 205, 253] },
  { value: 3.6, color: [206, 254, 206] },
  { value: 5.66, color: [255, 254, 206] },
  { value: 8.75, color: [254, 204, 157] },
  { value: 11.32, color: [253, 157, 112] },
  { value: 14.4, color: [253, 103, 61] },
  { value: 17.49, color: [252, 54, 29] },
  { value: 21.09, color: [202, 53, 21] },
  { value: 24.69, color: [202, 8, 19] },
  { value: 28.81, color: [151, 4, 11] },
  { value: 32.92, color: [0, 0, 0] },
];

export const initialState = {
  tileLayerOptions: {
    maxZoom: 6,
    minZoom: 1,
  },
  particleOptions: {
    decodeChannels: 'rg',
    decodeMin: -50,
    decodeMax: 50,
    color: [255, 255, 255, 40],
    size: 1.5,
    speed: 0.0005,
    maxAmount: 128,
    density: 5,
    refreshInterval: 800,
    fadeFactor: 0.06,
  },
  arrowLayerOptions: {
    decodeAsWaves: true,
    decodeChannels: 'rg',
    decodeMin: -30,
    decodeMax: 30,
    size: 30,
    speed: 0.00015,
    maxAmount: 128,
    density: 1,
    refreshInterval: 1000,
    color: [255, 255, 255, 80],
    fastColor: [255, 255, 0],
    fastSpeed: 200,
    rttTimestep: 75,
  },
  gradientColoringFragmentOptions: {
    decode: {
      channel: 'b',
      min: 0,
      max: 33,
    },
    stops: scaleInMetersPerSecond,
    smooth: false,
    opacity: 0.6,
  },
};

const handlers = {
  [SET_WIND_COLORS]: (state, { colors }) => ({
    ...state,
    gradientColoringFragmentOptions: {
      ...state.gradientColoringFragmentOptions,
      stops: colors,
    },
  }),
  [SET_WIND_ARROW_OPTIONS]: (state, { options }) => ({
    ...state,
    arrowLayerOptions: {
      ...state.arrowLayerOptions,
      ...options,
    },
  }),
  [SET_WIND_PARTICLE_OPTIONS]: (state, { options }) => ({
    ...state,
    particleOptions: {
      ...state.particleOptions,
      ...options,
    },
  }),
  [OVERWRITE_CHART_CONFIG]: (_, { config }) => ({
    ...config.wind,
  }),
};

export default createReducer(handlers, initialState);



// WEBPACK FOOTER //
// ./src/reducers/charts/wind.js